// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left',
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
    if (jQ(searchBoxId).closest('.searchbox').length > 0) {
        this.setSuggestionWidth(searchBoxId, 300);
    }
};
BCSfFilter.prototype.buildSuggestionProductList = function(a, b, c, d, e) {
    var f = "";
    f += this.buildSuggestionHeader(d.label, "product");
    var g = this.buildSuggestionDidYouMean(a, e, c);
    if ("" != g && (f += '<li class="' + this.class.searchSuggestionItem + ' bc-sf-search-suggestion-dym" aria-label="Did you mean">' + g + "</li>"),
        Object.keys(b).length > 0) {
        var h = 0;
    for (var i in b) {
        if (!(h < d.number))
            break;
        var j = b[i];
        if (!1 === this.getSettingValue("search.productAvailable") || this.getSettingValue("search.productAvailable") && j.available) {
            var k = this.customizeSuggetionProductTitle(j.title, a, b);
            k = this.highlightSuggestionResult(k, a);
            var l = this.buildProductItemUrl(j, !1)
            , m = j.images_info.length > 0 ? this.optimizeImage(j.images_info[0].src, "200x") : bcSfFilterConfig.general.no_image_url
            , n = null !== j.skus && j.skus.length > 0 ? j.skus[0] : ""
            , o = this.class.searchSuggestion
            , p = this.getSettingValue("search.openProductNewTab") ? 'target="_blank"' : "";

            let tags = j["tags"];
            let publisher = "";
            tags.map(tag => {
                if(tag.includes("product_attribute_publisher_")){
                  publisher = tag.replace("product_attribute_publisher_","");
              }
          });
            f += '<li class="' + this.class.searchSuggestionItem + " " + this.class.searchSuggestionItem + '-product" aria-label="' + this.escape(d.label) + ": " + this.escape(j.title) + '">',
            f += '<a href="' + l + '" ' + p + ">",
            this.getSettingValue("search.showSuggestionProductImage") && (f += '<div class="' + o + '-left"><img src="' + m + '" /></div>'),
            f += '<div class="' + o + '-right">',
            f += '<div class="' + o + '-product-title">' + k + "</div>";
            if(publisher != ""){
                f += `<div class="search-publisher">Publisher: ${publisher}</div>`;
            }
            this.getSettingValue("search.showSuggestionProductSku") && (f += '<div class="' + o + '-product-sku">SKU: ' + n + "</div>"),

            this.getSettingValue("search.showSuggestionProductVendor") && (f += '<div class="' + o + '-product-vendor">' + j.vendor + "</div>"),
            f += this.buildSuggestionProductPrice(j),
            f += "</div>",
            f += "</a>",
            f += "</li>",
            h++
        }
    }
}
return f
}